import { Component } from "@angular/core";
import {
  NgbAccordionConfig,
  NgbActiveModal,
  NgbModal,
  NgbNavChangeEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { GlobalService } from "../../service/global.service";

/**
 * The NeedHelpComponent adds help's section at page level.
 */
@Component({
  selector: "app-need-help",
  templateUrl: "need-help.component.html",
  providers: [NgbAccordionConfig, NgbActiveModal],
})
export class NeedHelpComponent {
  faqs: any;
  videos: any;
  contactDetails: any;
  resourceDetails: any;
  showHelp: boolean;
  serviceCalled: boolean;

  constructor(
    private service: GlobalService,
    private accordionConfig: NgbAccordionConfig,
    public modalService: NgbModal
  ) {}

  loadHelp(moduleName, path, pageId) {
    this.getHelpDetails(moduleName, path, pageId);
    this.showHelp = true;
    //this.serviceCalled = false;
  }

  getHelpDetails(moduleName, path, pageId) {
    this.service.getHelpDetails(moduleName, path, pageId).subscribe(
      (response) => {
        const res = response as any;
        this.faqs = res.faqList;
        this.videos = res.videoList;
        this.contactDetails = res.contactDetailList;
        this.resourceDetails = res.resourceList;
        this.serviceCalled = true;
        document.getElementById("need-help-btn").click();
      },
      (error) => {
        this.serviceCalled = true;
        document.getElementById("need-help-btn").click();
      }
    );
  }

  public beforeChange($event: NgbNavChangeEvent) {
    const panelId = $event.activeId;
    if ($event.nextId) {
      document.getElementById("square-" + panelId).className =
        "fa fa-lg fa-minus-square-o";
    } else {
      document.getElementById("square-" + panelId).className =
        "fa fa-lg fa-plus-square-o";
    }
  }

  open(content) {
    this.modalService
      .open(content, { centered: true, size: "md", backdrop: "static" })
      .result.then(
        (result) => {},
        (reason) => {}
      );
  }
}
